import { useContext } from "react";

import { FeatureFlagsContext } from "./FeatureFlagsContext";
import { type Feature } from "./featureDefaults";

/**
 * Returns current feature set.
 * Takes into account overrides.
 */
export function useFeatures() {
    const features = useContext(FeatureFlagsContext);
    return features;
}

/**
 * Returns true if given feature is enabled or false otherwise.
 * Takes into account overrides.
 */
export function useFeatureEnabled(feature: Feature) {
    const features = useFeatures();
    return features[feature];
}
